import appConstants from '../constants';
import fetchService from './fetchService';
import UserModel from '../models/userModel';

const SERVICE_URL = `${appConstants.SERVICE_BASE_URL}${appConstants.SERVICE_REQUEST_GET_LOGGED_IN_USER_URL}`;

function processData(data) {
  let user = new UserModel();
  if (!!data && (data?.LDAP_USER !== undefined)) {
    let ldapUser = `${data.LDAP_USER}`.trim().toLowerCase();
    user.setIsLoggedInFlag(ldapUser !== 'guest');
    user.setName(data?.COMMON_NAME||ldapUser);
    user.setId(ldapUser);
    user.setAccessLevel(data?.ACCESS_LEVEL === undefined? '1':`${data.ACCESS_LEVEL}`);
    user.setSessionId(data?.SESSION_ID);
    user.setIPAddress(data?.IP_ADDRESS);
  }

  //user.setIsLoggedInFlag(true);
  //user.setName('Renaud L.');
  //user.setId('rlapoele');
  //user.setAccessLevel('4');
  //user.setSessionId(null);
  //user.setIPAddress(null);

  return user;
}

export default async function fetchLoggedInUser() {
  const fetchedDataObject =
    await fetchService(
      'fetchLoggedInUser',
      SERVICE_URL,
      appConstants.SERVICE_REQUEST_GET_LOGGED_IN_USER_CONFIG,
      true,
    );

  return !fetchedDataObject.success ?
    {
      hasError: true,
      errorMessage: fetchedDataObject.statusMessage
    } :
    {
      hasError: false,
      user: processData(fetchedDataObject.data)
    };
}
